export default __webpack_public_path__ + "static/media/IMG_5073.5796d87b.png";